<script lang="ts">
  let clazz = "";
  export { clazz as class };
</script>

<div class={`spinner ${clazz}`}>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    aria-label="Loading"
    aria-hidden="true"
    class="w-full h-full"
    data-testid="spinner">
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M10.72,19.9a8,8,0,0,1-6.5-9.79A7.77,7.77,0,0,1,10.4,4.16a8,8,0,0,1,9.49,6.52A1.54,1.54,0,0,0,21.38,12h.13a1.37,1.37,0,0,0,1.38-1.54,11,11,0,1,0-12.7,12.39A1.54,1.54,0,0,0,12,21.34h0A1.47,1.47,0,0,0,10.72,19.9Z"
      fill="currentColor" />
  </svg>
</div>

<style>
  .spinner {
    transform-origin: center;
    animation: spinner-animation 1s infinite linear;
  }

  @keyframes spinner-animation {
    100% {
      transform: rotate(360deg);
    }
  }
</style>
